import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DB2Dataset } from 'app/model/dataset/db2.dataset';

import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.db2.copySourceType,
    display:  [
        format(stringResources.ModelName_CopySourceTemplate, stringResources.Db2_DisplayText),
        format(stringResources.ModelName_CopySourcesTemplate, stringResources.Db2_DisplayText)
    ],
    tags: {
        datasetModel: [
            Metamodel.modelFor(DB2Dataset)
        ]
    }
})
export class DB2CopySource extends TabularCopySource {
}
